export function requiredBookingFormErrors(form, availableDates = []) {
  const errors = {};
  const selected = String(form.visitDate || "").trim();
  if (!selected) {
    errors.visitDate = "Select a date";
  } else if (
    availableDates.length > 0 &&
    !availableDates.some((item) => item?.date === selected)
  ) {
    errors.visitDate = "Select a date";
  }
  if (!form.doctorId) errors.doctorId = "Select a doctor";
  if (!form.visitTypeCode) errors.visitTypeCode = "Select a visit type";
  if (!form.fullName?.trim()) errors.fullName = "Name is required";
  if (!/^\d{10}$/.test(String(form.mobile || "").trim())) {
    errors.mobile = "Enter a valid 10-digit mobile number";
  }
  if (!form.dob) errors.dob = "Date of birth is required";
  if (!form.gender) errors.gender = "Gender is required";
  return errors;
}

/** Same staff rule: a single active association is used automatically. */
export function resolveDoctorDepartment(doctor) {
  const departments = doctor?.departments || [];
  if (departments.length === 1) return departments[0];
  if (departments.length === 0) return null;
  const primary = departments.filter(
    (dept) => dept?.primaryYn === "Y" || dept?.primaryYn === "y" || dept?.primaryYn === 89,
  );
  if (primary.length === 1) return primary[0];
  return departments[0];
}

export function isCampAvailableForDate(catalog, date) {
  const option = (catalog?.availableDates || []).find((item) => item?.date === date);
  return Boolean(option?.campAvailable);
}

/** Medical Camp is the default only on catalog dates marked campAvailable (15–16 Aug 2026). */
export function defaultVisitTypeForDate(catalog, date) {
  return isCampAvailableForDate(catalog, date) ? "CAMP" : "NEW";
}

export function displayConsultationFee(association, visitTypeCode) {
  if (String(visitTypeCode || "").toUpperCase() === "CAMP") return 0;
  if (!association) return null;
  return association.consultFee ?? null;
}

export function formatConsultationFee(amount) {
  if (amount == null || amount === "") return null;
  const numeric = Number(amount);
  if (Number.isNaN(numeric)) return null;
  return `₹${numeric}`;
}

export function departmentLabel(department) {
  return department?.label || department?.designation || department?.departmentId || "";
}
